import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73ba42ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "send-mail-dialog" }
const _hoisted_2 = { class: "field-row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field-label" }, "发送方式", -1))
const _hoisted_4 = { class: "send-mode-group" }
const _hoisted_5 = {
  key: 1,
  type: "button",
  class: "send-mode-btn active"
}
const _hoisted_6 = {
  key: 0,
  class: "field-row"
}
const _hoisted_7 = { class: "field-label-row" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field-label required" }, "分公司", -1))
const _hoisted_9 = {
  key: 0,
  class: "field-error"
}
const _hoisted_10 = {
  key: 1,
  class: "field-row"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field-label required" }, "邮箱地址", -1))
const _hoisted_12 = {
  key: 0,
  class: "field-error"
}
const _hoisted_13 = {
  key: 2,
  class: "field-row"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field-label required" }, "邮箱地址", -1))
const _hoisted_15 = {
  key: 0,
  class: "field-error"
}

import { computed, ref, watch } from 'vue';
import { message } from 'ant-design-vue';
import {
  queryLastMailReceiver,
  querySalesOfficePage,
  sendReceivableEmail,
} from './index';

export type SendMailMode = 'summary' | 'office' | 'designated';
/** summary=按汇总发邮件；branch=按分公司发邮件（含指定人） */
export type SendMailDialogType = 'summary' | 'branch';


export default /*#__PURE__*/_defineComponent({
  __name: 'SendMailDialog',
  props: {
    visible: { type: Boolean },
    dialogType: { default: 'summary' }
  },
  emits: ["update:visible"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:visible', value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { visible: boolean, dialogType: SendMailDialogType }





const OFFICE_PAGE_SIZE = 15;
const OFFICE_ALL_PAGE_SIZE = 200;

const loading = ref(false);
const submitting = ref(false);
const sendMode = ref<SendMailMode>('summary');
const mailReceivers = ref('');
const designatedReceivers = ref('');
const receiverInvalid = ref(false);
const summaryReceiverInvalid = ref(false);

const officeOptions = ref<{ value: string; label: string }[]>([]);
const selectedOfficeCodes = ref<string[]>([]);
const officeInvalid = ref(false);
const officeFetching = ref(false);
const selectingAll = ref(false);
const officeKeyword = ref('');
const officeSearchValue = ref('');
const officePage = ref(1);
const officeTotalPages = ref(1);
const officeTotalElements = ref(0);
const officeHasMore = computed(() => officePage.value < officeTotalPages.value);
const allOfficesSelected = computed(
  () =>
    officeTotalElements.value > 0 &&
    selectedOfficeCodes.value.length >= officeTotalElements.value,
);
const isBranchDialog = computed(() => props.dialogType === 'branch');
const dialogTitle = computed(() =>
  isBranchDialog.value ? '按分公司发邮件' : '按汇总发邮件',
);

let officeSearchTimer: ReturnType<typeof setTimeout> | null = null;
let officeLoadingMore = false;
let officeFetchSeq = 0;

/** 后端可能用逗号/分号分隔，统一成换行便于编辑 */
function normalizeReceivers(raw?: string | null) {
  const text = (raw ?? '').trim();
  if (!text) return '';
  return text
    .split(/[\n,;，；]+/)
    .map((item) => item.trim().replace(/^['"]+|['"]+$/g, ''))
    .filter(Boolean)
    .join('\n');
}

/** 提交给后端：多个邮箱用英文分号拼接 */
function formatReceiverForApi(raw: string) {
  return raw
    .split(/[\n,;，；]+/)
    .map((item) => item.trim().replace(/^['"]+|['"]+$/g, ''))
    .filter(Boolean)
    .join(';');
}

async function loadLastReceiver() {
  loading.value = true;
  mailReceivers.value = '';
  try {
    const data = await queryLastMailReceiver();
    const receiver = (data?.receiver ?? '').trim();
    if (receiver) {
      mailReceivers.value = normalizeReceivers(receiver);
    }
  } catch (error) {
    message.error(error instanceof Error ? error.message : '查询最近收件人失败');
  } finally {
    loading.value = false;
  }
}

function changeSendMode(mode: SendMailMode) {
  if (sendMode.value === mode) return;
  sendMode.value = mode;
  selectedOfficeCodes.value = [];
  officeInvalid.value = false;
}

watch(
  () => props.visible,
  (open) => {
    if (!open) return;
    sendMode.value = isBranchDialog.value ? 'office' : 'summary';
    mailReceivers.value = '';
    designatedReceivers.value = '';
    receiverInvalid.value = false;
    summaryReceiverInvalid.value = false;
    selectedOfficeCodes.value = [];
    officeInvalid.value = false;
    officeOptions.value = [];
    officeKeyword.value = '';
    officeSearchValue.value = '';
    officePage.value = 1;
    officeTotalPages.value = 1;
    officeTotalElements.value = 0;
    submitting.value = false;
    if (!isBranchDialog.value) {
      loadLastReceiver();
    }
  },
);

function uniqueOfficeCodes(codes: string[]) {
  return [...new Set(codes.map((code) => code.trim()).filter(Boolean))];
}

function clearOfficeSearch() {
  if (officeSearchTimer) {
    clearTimeout(officeSearchTimer);
    officeSearchTimer = null;
  }
  const hadKeyword = !!officeKeyword.value || !!officeSearchValue.value;
  officeSearchValue.value = '';
  officeKeyword.value = '';
  if (hadKeyword) {
    fetchOfficeOptions(true);
  }
}

function onOfficeChange(values: string[]) {
  officeInvalid.value = false;
  const unique = uniqueOfficeCodes(values ?? []);
  if (unique.length !== (values ?? []).length || unique.some((code, index) => code !== values[index])) {
    selectedOfficeCodes.value = unique;
  }
  clearOfficeSearch();
}

function mergeOfficeOptions(
  prev: { value: string; label: string }[],
  next: { value: string; label: string }[],
) {
  const map = new Map<string, { value: string; label: string }>();
  [...prev, ...next].forEach((item) => {
    const value = (item?.value ?? '').trim();
    if (!value || map.has(value)) return;
    map.set(value, { value, label: (item.label ?? '').trim() || value });
  });
  return [...map.values()];
}

async function fetchOfficeOptions(reset: boolean) {
  if (!reset && (officeFetching.value || officeLoadingMore || !officeHasMore.value)) return;

  const seq = ++officeFetchSeq;
  const nextPage = reset ? 1 : officePage.value + 1;
  const keyword = officeKeyword.value;
  officeFetching.value = true;
  if (!reset) officeLoadingMore = true;
  try {
    const pageData = await querySalesOfficePage({
      currentPage: nextPage,
      size: OFFICE_PAGE_SIZE,
      keyword,
    });
    if (seq !== officeFetchSeq) return;
    const mapped = (pageData.content ?? []).map((item) => ({
      value: item.code,
      label: item.name || item.code,
    }));
    officeOptions.value = reset ? withSelectedOfficeLabels(mapped) : mergeOfficeOptions(officeOptions.value, mapped);
    officePage.value = nextPage;
    officeTotalPages.value = Math.max(1, pageData.totalPages || 1);
    if (!keyword) {
      officeTotalElements.value = pageData.totalElements || 0;
    }
  } catch (error) {
    if (seq !== officeFetchSeq) return;
    if (reset) officeOptions.value = withSelectedOfficeLabels([]);
    message.error(error instanceof Error ? error.message : '获取分公司失败');
  } finally {
    if (seq === officeFetchSeq) {
      officeFetching.value = false;
      officeLoadingMore = false;
    }
  }
}

/** 下拉按接口顺序展示；已选项若不在本页，仍保留名称，避免标签变成编码 */
function withSelectedOfficeLabels(mapped: { value: string; label: string }[]) {
  const selected = new Set(selectedOfficeCodes.value);
  const kept = officeOptions.value.filter(
    (item) => selected.has(item.value) && !mapped.some((next) => next.value === item.value),
  );
  return mergeOfficeOptions(mapped, kept);
}

function onOfficeSearch(keyword: string) {
  const next = keyword ?? '';
  officeSearchValue.value = next;
  if (next === officeKeyword.value) return;
  officeKeyword.value = next;
  if (officeSearchTimer) clearTimeout(officeSearchTimer);
  officeSearchTimer = setTimeout(() => {
    fetchOfficeOptions(true);
  }, 300);
}

function onOfficeDropdownVisible(open: boolean) {
  if (!open) return;
  if (officeSearchTimer) {
    clearTimeout(officeSearchTimer);
    officeSearchTimer = null;
  }
  officeSearchValue.value = '';
  officeKeyword.value = '';
  fetchOfficeOptions(true);
}

function onOfficePopupScroll(e: Event) {
  const target = e.target as HTMLElement;
  if (!target) return;
  const nearBottom = target.scrollTop + target.offsetHeight >= target.scrollHeight - 24;
  if (nearBottom) {
    fetchOfficeOptions(false);
  }
}

async function loadAllOffices() {
  const all: { value: string; label: string }[] = [];
  let page = 1;
  let totalPages = 1;
  let totalElements = 0;
  do {
    const pageData = await querySalesOfficePage({
      currentPage: page,
      size: OFFICE_ALL_PAGE_SIZE,
      keyword: '',
    });
    all.push(
      ...(pageData.content ?? []).map((item) => ({
        value: item.code,
        label: item.name || item.code,
      })),
    );
    totalPages = Math.max(1, pageData.totalPages || 1);
    totalElements = pageData.totalElements || all.length;
    page += 1;
  } while (page <= totalPages);
  return { all, totalElements };
}

async function handleSelectAll() {
  if (selectingAll.value) return;
  if (allOfficesSelected.value) {
    selectedOfficeCodes.value = [];
    return;
  }
  selectingAll.value = true;
  try {
    const { all, totalElements } = await loadAllOffices();
    officeOptions.value = mergeOfficeOptions(officeOptions.value, all);
    officeTotalElements.value = totalElements;
    selectedOfficeCodes.value = uniqueOfficeCodes(all.map((item) => item.value));
  } catch (error) {
    message.error(error instanceof Error ? error.message : '全选分公司失败');
  } finally {
    selectingAll.value = false;
  }
}

function handleCancel() {
  if (submitting.value) return;
  emit('update:visible', false);
}

async function handleConfirm() {
  if (submitting.value) return;

  if (sendMode.value === 'summary') {
    const receiver = formatReceiverForApi(mailReceivers.value);
    if (!receiver) {
      summaryReceiverInvalid.value = true;
      message.error('邮箱地址 必填');
      return;
    }
    summaryReceiverInvalid.value = false;
    submitting.value = true;
    try {
      await sendReceivableEmail({ emailType: '1', receiver });
      message.success('发送成功');
      emit('update:visible', false);
    } catch (error) {
      message.error(error instanceof Error ? error.message : '发送邮件失败');
    } finally {
      submitting.value = false;
    }
    return;
  }

  const saleOfficeCodeList = uniqueOfficeCodes(selectedOfficeCodes.value);
  if (saleOfficeCodeList.length === 0) {
    officeInvalid.value = true;
    message.error('分公司 必填');
    return;
  }
  officeInvalid.value = false;

  if (sendMode.value === 'designated') {
    const receiver = formatReceiverForApi(designatedReceivers.value);
    if (!receiver) {
      receiverInvalid.value = true;
      message.error('邮箱地址 必填');
      return;
    }
    receiverInvalid.value = false;
    submitting.value = true;
    try {
      await sendReceivableEmail({ emailType: '3', receiver, saleOfficeCodeList });
      message.success('发送成功');
      emit('update:visible', false);
    } catch (error) {
      message.error(error instanceof Error ? error.message : '发送邮件失败');
    } finally {
      submitting.value = false;
    }
    return;
  }

  submitting.value = true;
  try {
    await sendReceivableEmail({ emailType: '2', saleOfficeCodeList });
    message.success('发送成功');
    emit('update:visible', false);
  } catch (error) {
    message.error(error instanceof Error ? error.message : '发送邮件失败');
  } finally {
    submitting.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: __props.visible,
    title: _unref(dialogTitle),
    width: 640,
    "confirm-loading": submitting.value,
    "mask-closable": false,
    "destroy-on-close": "",
    "ok-text": "确认发送",
    "cancel-text": "取消",
    onOk: handleConfirm,
    onCancel: handleCancel
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_spin, { spinning: loading.value }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                (_unref(isBranchDialog))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(["send-mode-btn", { active: sendMode.value === 'office' }]),
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (changeSendMode('office')))
                      }, " 按分公司发邮件 ", 2),
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(["send-mode-btn", { active: sendMode.value === 'designated' }]),
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (changeSendMode('designated')))
                      }, " 按分公司指定人发 ", 2)
                    ], 64))
                  : (_openBlock(), _createElementBlock("button", _hoisted_5, " 按汇总发邮件 "))
              ])
            ]),
            (sendMode.value === 'office' || sendMode.value === 'designated')
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createVNode(_component_a_button, {
                      type: "link",
                      class: "select-all-btn",
                      loading: selectingAll.value,
                      onClick: handleSelectAll
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(allOfficesSelected) ? '取消全选' : '全选'), 1)
                      ]),
                      _: 1
                    }, 8, ["loading"])
                  ]),
                  _createVNode(_component_a_select, {
                    value: selectedOfficeCodes.value,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((selectedOfficeCodes).value = $event)),
                    mode: "multiple",
                    "show-search": "",
                    "allow-clear": "",
                    placeholder: "请选择分公司",
                    options: officeOptions.value,
                    "search-value": officeSearchValue.value,
                    "filter-option": false,
                    "max-tag-count": 3,
                    loading: officeFetching.value,
                    class: _normalizeClass({ 'field-invalid': officeInvalid.value }),
                    style: {"width":"100%"},
                    onSearch: onOfficeSearch,
                    onPopupScroll: onOfficePopupScroll,
                    onDropdownVisibleChange: onOfficeDropdownVisible,
                    onChange: onOfficeChange
                  }, null, 8, ["value", "options", "search-value", "loading", "class"]),
                  (officeInvalid.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, "必填"))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (sendMode.value === 'summary')
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _hoisted_11,
                  _createVNode(_component_a_textarea, {
                    value: mailReceivers.value,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((mailReceivers).value = $event)),
                    class: _normalizeClass(["mail-receivers-input", { 'field-invalid': summaryReceiverInvalid.value }]),
                    rows: 5,
                    placeholder: "请输入邮箱地址，多个邮箱请换行填写",
                    onInput: _cache[4] || (_cache[4] = ($event: any) => (summaryReceiverInvalid.value = false))
                  }, null, 8, ["value", "class"]),
                  (summaryReceiverInvalid.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, "必填"))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (sendMode.value === 'designated')
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _hoisted_14,
                  _createVNode(_component_a_textarea, {
                    value: designatedReceivers.value,
                    "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((designatedReceivers).value = $event)),
                    class: _normalizeClass(["mail-receivers-input", { 'field-invalid': receiverInvalid.value }]),
                    rows: 5,
                    placeholder: "请输入邮箱地址，多个邮箱请换行填写",
                    onInput: _cache[6] || (_cache[6] = ($event: any) => (receiverInvalid.value = false))
                  }, null, 8, ["value", "class"]),
                  (receiverInvalid.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, "必填"))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["spinning"])
    ]),
    _: 1
  }, 8, ["visible", "title", "confirm-loading"]))
}
}

})